import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";
require("./booth.scss");

class DazlingDesigns extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Dazzling Designs</div>
        <Card.Img className="booth-image" src="/dazzling-designs.jpg" />
        <Card.Text className="booth-description">
          From whimsical balloon animals to dazzling temporary tattoos, we've
          got something for everyone
        </Card.Text>
      </div>
    );
  }
}

export default DazlingDesigns;
